import { useState } from 'react'

import type { ReactElement } from 'react'
import type { ISwitchButton } from '~/components/Buttons/SwitchButton'
import type { IAppMau } from '~/types/okr'

import TableRow from '../TableRow'

import BlockTitle from '~/components/Blocks/Title'
import SwitchButton, { getDefaultDeviceTypeSwitchButtons } from '~/components/Buttons/SwitchButton'
import GridItemLayout from '~/components/GridItemLayout'

import './styles.scss'

interface Props {
  topApps?: {
    android: IAppMau[]
    ios: IAppMau[]
  }
}

const Top5Block = ({ topApps }: Props): ReactElement => {
  /** Local state */

  const [switchButtons, setSwitchButtons] = useState<ISwitchButton[]>(
    getDefaultDeviceTypeSwitchButtons({ withWeb: false })
  )

  const [selectedTopApps, setSelectedTopApps] = useState<IAppMau[]>(topApps?.ios || [])

  /** Handlers */

  const handleSwitchButtonSelectionChange = (buttonId: string) => {
    const selectedButton = switchButtons.find(({ id }) => id === buttonId)

    setSwitchButtons(
      switchButtons.map((button) => ({
        ...button,
        isActive: button.id === buttonId,
      }))
    )

    if (selectedButton?.id === 'ios') {
      setSelectedTopApps(topApps?.ios || [])
    } else if (selectedButton?.id === 'android') {
      setSelectedTopApps(topApps?.android || [])
    }
  }

  /** Render */

  return (
    <GridItemLayout className="top-5-block-component">
      <div className="title-wrapper">
        <BlockTitle>Top 5 apps MAU</BlockTitle>
        <SwitchButton
          buttons={switchButtons}
          onButtonSelectionChange={handleSwitchButtonSelectionChange}
          size="small"
        />
      </div>
      <div className="table-wrapper">
        {selectedTopApps.map(({ app_icon_url, app_id, app_key, device_type, mau, name }) => (
          <TableRow
            appIcon={app_icon_url}
            appId={app_id}
            appKey={app_key}
            appName={name || app_key}
            deviceType={device_type}
            key={app_key}
            mau={mau}
            platform={device_type}
            type="normal"
          />
        ))}
      </div>
    </GridItemLayout>
  )
}

export default Top5Block
